import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../lib/cart";
import { useToast } from "../lib/toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCartShopping } from "@fortawesome/free-solid-svg-icons";

const fmt = (n: number) => n.toLocaleString("ko-KR");

export default function Cart() {
  const { items, update, remove, subtotal, clear } = useCart();
  const { push } = useToast();
  const nav = useNavigate();
  const shipping = subtotal === 0 ? 0 : subtotal >= 300_000 ? 0 : 10_000;
  const total = subtotal + shipping;

  if (items.length === 0) {
    return (
      <main id="main-content" className="container" style={{ padding: "var(--s-16) var(--s-5)", textAlign: "center", maxWidth: 520 }}>
        <div style={{ fontSize: 48, color: "var(--text-muted)", marginBottom: 12 }}>
          <FontAwesomeIcon icon={faCartShopping} />
        </div>
        <h1 className="h-title">장바구니가 비어있습니다</h1>
        <p className="muted" style={{ marginTop: 8, marginBottom: 24 }}>카탈로그에서 필요한 자재를 추가하세요.</p>
        <Link to="/catalog" className="btn btn-primary btn-lg">카탈로그 보기</Link>
      </main>
    );
  }

  return (
    <main id="main-content" className="container cart-grid" style={{ padding: "var(--s-8) var(--s-5)", display: "grid", gridTemplateColumns: "1fr 340px", gap: "var(--s-8)" }}>
      <div>
        <p className="eyebrow" style={{ marginBottom: 4 }}>Cart</p>
        <h1 className="h-title" style={{ marginBottom: 20 }}>장바구니 <span className="muted" style={{ fontSize: 15, fontWeight: 400 }}>({items.length})</span></h1>
        <div className="card">
          <table>
            <thead><tr>
              <th>상품</th><th style={{ width: 120 }}>단가</th><th style={{ width: 140 }}>수량</th><th style={{ width: 120 }}>합계</th><th style={{ width: 60 }}></th>
            </tr></thead>
            <tbody>
              {items.map((it) => (
                <tr key={it.product.id}>
                  <td>
                    <div style={{ fontWeight: 600 }}>{it.product.name}</div>
                    <div className="muted" style={{ fontSize: 15, fontFamily: "monospace" }}>{it.product.sku}</div>
                  </td>
                  <td>{fmt(it.product.price)}원/{it.product.unit}</td>
                  <td>
                    <input type="number" min={1} max={it.product.stock} value={it.quantity}
                      onChange={(e) => update(it.product.id, Number(e.target.value) || 1)}
                      style={{ width: 90 }} />
                  </td>
                  <td style={{ fontWeight: 600 }}>{fmt(it.product.price * it.quantity)}원</td>
                  <td>
                    <button className="btn btn-ghost btn-sm" aria-label="삭제"
                      onClick={() => { remove(it.product.id); push(`${it.product.name} 삭제됨`, "info"); }}>
                      <FontAwesomeIcon icon={faXmark} style={{ width: 12, height: 12 }} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="row" style={{ marginTop: 16, justifyContent: "space-between" }}>
          <Link to="/catalog" className="btn btn-outline btn-sm">계속 쇼핑</Link>
          <button className="btn btn-ghost btn-sm" onClick={() => { if (window.confirm("장바구니를 모두 비울까요?")) { clear(); push("장바구니를 비웠습니다", "info"); } }}>장바구니 비우기</button>
        </div>
      </div>

      <aside>
        <div className="card" style={{ padding: "var(--s-5)", position: "sticky", top: 80 }}>
          <h3 className="h-section">주문 요약</h3>
          <div className="stack" style={{ gap: 10 }}>
            <Row label="상품 합계" value={`${fmt(subtotal)}원`} />
            <Row label="배송비" value={shipping === 0 ? "무료" : `${fmt(shipping)}원`} hint={shipping > 0 ? "30만원 이상 무료" : undefined} />
            <div style={{ borderTop: "1px solid var(--border)", paddingTop: 12, display: "flex", justifyContent: "space-between" }}>
              <span style={{ fontWeight: 600 }}>결제 예정 금액</span>
              <span style={{ fontSize: 22, fontWeight: 800, fontFamily: "var(--font-display)", color: "var(--primary)" }}>{fmt(total)}원</span>
            </div>
          </div>
          <button className="btn btn-cta btn-lg" style={{ width: "100%", marginTop: 16 }} onClick={() => nav("/checkout")}>
            주문서 작성
          </button>
          <p className="muted" style={{ fontSize: 15, marginTop: 10, textAlign: "center" }}>
            VAT 별도 · 사업자 가격 적용됨
          </p>
        </div>
      </aside>
      <style>{`
        @media (max-width: 860px) {
          .cart-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </main>
  );
}

function Row({ label, value, hint }: { label: string; value: string; hint?: string }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
      <span className="muted" style={{ fontSize: 15 }}>
        {label}
        {hint && <span style={{ fontSize: 15, marginLeft: 6 }}>· {hint}</span>}
      </span>
      <span style={{ fontWeight: 500 }}>{value}</span>
    </div>
  );
}
